<template>
	<div class="box">
		<div class="p_flex p_f_c">
			<el-button type="info" icon="el-icon-circle-plus-outline" @click="goAdd(0)">从我的题库添加题目</el-button>
			<el-button type="info" icon="el-icon-circle-plus-outline" @click="goAdd(1)">从校本题库添加题目</el-button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		breadcrumb:null,
		grades:null,
		names:null,
		deleteId:Array
	},
	data() {
		return {
				grade:"",
				breadcrum:"",
				ccc:"",
				ids:[]
		};
	},
	watch: {
		names:{
			handler(i,o){
				// console.log(i)
				this.ccc=i
			}
		},
		grades:{
			handler(i,o){
				// console.log(i)
				this.grade=i
			}
		},
		breadcrumb:{
			handler(i,o){
				// console.log(i)
				this.breadcrum=i
			}
		},
		deleteId(nvl,ovl){
			this.ids = nvl
		}
	},
	created() {
		if( this.$route.query.id ){
			this.ids = this.$route.query.id 
		}
		if(this.$route.query.id){
			this.grade=this.$route.query.jkh
			this.breadcrum=this.$route.query.hjs
		}
		if(this.$route.query.js){
			var ojbk=this.$route.query.js.split("|")    //分割完返回过来后是一个数组
			// console.log(ojbk)
			this.$request.ajax(this).post("/api_teacher/question_list",{
				ids:ojbk
			}).then(res=>{
				// console.log(res)
				this.grade=res.data.list[0].grade
				this.breadcrum=res.data.list[0].subject
			})
		}
		
	},
	methods: {
		indexInfo() {
			var info = document.body;
			// console.log(info);
		},
		goAdd(i) {
			if(this.grade==""){
				this.$message.error("请选择年级不能为空！")
				return
			}
			if(this.breadcrum==""){
				this.$message.error("请选择学科不能为空！")
				return
			}
			this.$router.push({
				path: `/ExerciseAdd/${i}`,
				query:{
					name:JSON.stringify(this.grade),
					ccc:this.ccc,
					names:JSON.stringify(this.breadcrum),
					forbid:true,
					ids:this.ids
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.box {
	background: #ffffff;
	padding: 20px 0
}
>>> .el-button {
	font-size: 20px;
	color: #00af63;
}
>>> .el-button--info {
	background-color: #f5f5f5;
	border-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/exerciseButton.vue